module.exports = __webpack_public_path__ + "img/cashpayment.e55ae789.png";